<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">
            RELATÓRIO DE ABONOS
          </h4>
          <div class="row">
            <div class="col-6" v-show="tela == 1">
              <BaseFiltroRelatorio
                tipo="basico"
                @pesquisar="pesquisar"
                :btEnviarEmail="false"
              />
            </div>
          </div>
          <div class="row pl-4 pr-4" v-show="tela == 2" id="imprimirFolha">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="col-6 d-flex justify-content-start hidden-print">
                <base-button
                  v-show="!printing"
                  type="info"
                  class="animation-on-hover"
                  @click="tela = 1"
                  ><i class="tim-icons icon-minimal-left"></i>
                  Voltar</base-button
                >
              </div>
              <div class="col-6 d-flex justify-content-end hidden-print">
                <base-button
                  v-show="!printing"
                  type="info"
                  class="animation-on-hover"
                  @click="imprimirFolha()"
                  simple
                >
                  <i class="tim-icons icon-paper"></i> Imprimir
                </base-button>
              </div>
            </div>
            <!--Cabecalho-->
            <div class="container p-3 rounded" style="background: #f9f9f9;">
              <div class="row">
                <div class="col-6">
                  <div class="row">
                    <div class="col text-left">
                      RELATÓRIO DE ABONOS
                    </div>
                  </div>
                  <div class="row">
                    <div class="col text-left">
                      {{
                        `PERÍODO: ${moment(payloadPesquisa.data_inicial).format(
                          "DD/MM/YYYY",
                        )} à
                                            ${moment(
                                              payloadPesquisa.data_final,
                                            ).format("DD/MM/YYYY")}`
                      }}
                    </div>
                  </div>

                  <div class="row">
                    <div
                      class="col text-left"
                      v-if="!payloadPesquisa.id_funcionario"
                    >
                      {{
                        `DEPARTAMENTO: ${
                          payloadPesquisa.departamento
                            ? payloadPesquisa.departamento.descricao
                            : "TODOS"
                        }`
                      }}
                    </div>
                    <div class="col text-left" v-else>
                      {{ `DEPARTAMENTO: NENHUM` }}
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col text-left"
                      v-if="!payloadPesquisa.id_funcionario"
                    >
                      {{
                        `POSTO DE TRABALHO: ${
                          payloadPesquisa.posto
                            ? payloadPesquisa.posto.local
                            : "TODOS"
                        }`
                      }}
                    </div>
                    <div class="col text-left" v-else>
                      {{ `POSTO DE TRABALHO: NENHUM` }}
                    </div>
                  </div>

                  <div class="row">
                    <div class="col text-left">
                      {{
                        `RELATÓRIO GERADO EM: ${moment().format(
                          "DD/MM/YYYY HH:mm",
                        )}`
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--Tabela de Resultados-->
            <div class="table-responsive p-3">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th scope="col">Empregado</th>
                    <th scope="col">Data</th>
                    <th scope="col">Horas</th>
                    <th scope="col">Descrição</th>
                    <th scope="col">Status</th>
                    <th scope="col">Anexo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in dados" :key="`${item.id}`">
                    <th>
                      <p class="m-0 p-0">{{ item.NOME }}</p>
                    </th>
                    <th>
                      <p class="m-0 p-0">{{ item.DATA_ABONO }}</p>
                    </th>
                    <th>
                      <p class="m-0 p-0">{{ item.horas }}</p>
                    </th>
                    <th>
                      <p class="m-0 p-0">
                        {{ item.DESCRICAO_TIPO_ABONO }}
                      </p>
                    </th>
                    <th>
                      <p class="m-0 p-0">
                        {{ carregarStatusAbono(item.status_abono) }}
                      </p>
                    </th>
                    <th>
                      <base-button
                        v-if="item.arquivo && item.arquivo != ''"
                        @click.native="visualizarAnexo(item)"
                        class="edit btn-link"
                        type="info"
                        size="sm"
                        icon
                      >
                        <i class="tim-icons icon-tap-02"></i>
                      </base-button>
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BaseFiltroRelatorio } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import moment from "moment";
import swal from "sweetalert2";

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseFiltroRelatorio,
  },
  computed: {},
  data() {
    return {
      isLoading: false,
      dados: [],
      payloadPesquisa: {},
      tela: 1,
      printing: false,
    };
  },
  methods: {
    carregarStatusAbono(status) {
      if (status !== "") {
        if (status === "A") return "Aguardando";
        if (status === "S") return "Aprovado";
        if (status === "N") return "Reprovado";
        else return "Aguardando";
      } else return "";
    },
    visualizarAnexo(item) {
      const tipo = item.arquivo.split(";")[0];
      if (tipo.includes("image")) {
        // é uma img
        let image = new Image();
        image.src = item.arquivo;
        var newTab = window.open();
        newTab.document.body.innerHTML = image.outerHTML;
      } else if (tipo.includes("pdf")) {
        const base64 = item.arquivo.split(",")[1];
        this.base64toPDF(base64);
      }
    },
    base64ToArrayBuffer(data) {
      var bString = window.atob(data);
      var bLength = bString.length;
      var bytes = new Uint8Array(bLength);
      for (var i = 0; i < bLength; i++) {
        var ascii = bString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    base64toPDF(data) {
      var bufferArray = this.base64ToArrayBuffer(data);
      var blobStore = new Blob([bufferArray], { type: "application/pdf" });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blobStore);
        return;
      }
      var data = window.URL.createObjectURL(blobStore);
      var link = document.createElement("a");
      document.body.appendChild(link);
      link.href = data;
      link.download = "file.pdf";
      link.click();
      window.URL.revokeObjectURL(data);
      link.remove();
    },
    imprimirFolha() {
      this.printing = true;
      this.isLoading = true;

      try {
        this.$nextTick(() => {
          this.$htmlToPaper("imprimirFolha", null, () => {
            this.printing = false;
            this.isLoading = false;
          });
        });
      } catch (error) {
        console.error("Erro ao imprimir a folha:", error);
        this.isLoading = false;
        this.printing = false;
      }
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
    moment: function(data) {
      return moment(data);
    },
    carregarRelatorio(payload) {
      let th = this;
      th.isLoading = true;
      this.axios
        .post("/api/abonos/relatorioAbonos", payload, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          if (response.data.status) {
            this.tela = 2;
            this.dados = response.data.data.dados;
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao solicitar relatório!",
              "error",
            );
          }
        })
        .catch((err) => {
          th.isLoading = false;
          console.log(err);
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao solicitar relatório!",
            "error",
          );
        });
    },
    pesquisar(event) {
      this.isLoading = true;
      this.payloadPesquisa = event;
      this.carregarRelatorio(event);
    },
  },
  watch: {},
};
</script>
<style></style>
